import { FaArrowsRotate } from "react-icons/fa6";
import "./Internal_nav.css";
import { IoMdArrowDown, IoMdEye, IoMdEyeOff, IoMdShare } from "react-icons/io";
import { FaFileAlt, FaRegArrowAltCircleUp } from "react-icons/fa";
import { useEffect, useRef, useState } from "react";
import Button from "react-bootstrap/Button";

import { GiSaveArrow } from "react-icons/gi";

import "./wallet.css";
import "./WalletDetailModal.css";

import { type } from "@testing-library/user-event/dist/type";
import { useForm } from "react-hook-form";
import { Alert, Form } from "react-bootstrap";
import { Watch } from "react-loader-spinner";

import { PaystackButton } from "react-paystack";
import { IoCheckmarkDone } from "react-icons/io5";
import moment from "moment";
import {
  MdKeyboardArrowLeft,
  MdOutlineKeyboardBackspace,
} from "react-icons/md";

import { useNavigate } from "react-router-dom";

import logo from "../../assets/redesignLogo2.jpg";
import SubHeader from "../subHeader";
import Sidebar from "../sideBar";
import { vitelWirelessAxios } from "../../utilities/axios";
import Modal from "../../modal/modal";
import html2canvas from "html2canvas";
import NewFooter from "../../FooterComponent/newFooter";
import { IoEye } from "react-icons/io5";
import { IoEyeOff } from "react-icons/io5";
import { IoRefresh } from "react-icons/io5";
import { IoCardOutline } from "react-icons/io5";
import walletImage from "../../assets/walletImage.png";
// import CalcWalletStat from "./CalcWalletStat";
import CalcWalletStat from "./CalcWalletStat";

let renderCount = 0;

const SubscribersWallet = () => {
  var airTimeTopUpData;

  const symbol = Intl.NumberFormat("en-US", {
    style: "currency",
    currencyDisplay: "narrowSymbol",
    currency: "NGN",
  })
    .formatToParts(0)
    .filter((part) => part.type === "currency")
    .map((part) => part.value)
    .join("");

  const [payReference, setPayReference] = useState();
  const userNumberDisplay = JSON.parse(
    localStorage.getItem("MSISDN") || "null"
  );
  //   const subscribInfoRaw = localStorage.getItem('subscriberInformation');
  const subscribInfoProcessed = JSON.parse(
    localStorage.getItem("vitelCommandData") || "null"
  );

  const [referenceCode, setReferenceCode] = useState("");
  const [amount, setAmount] = useState("");
  const [refreshPending, setRefreshPending] = useState(false);
  const [showStateMent, setShowStateMent] = useState(false);
  const [purchaseDate, setPurchaseDate] = useState("");
  const [walletTopUpPending, setWalletTopUpPending] = useState(false);
  const [walletDisplayData, setWalletDisplayData] = useState("");
  const [success, setSuccess] = useState(false);
  const [transData, setTransData] = useState([]);
  const [firstPaystackCallPending, setFirstPaystackCallPending] =
    useState(false);
  const [isModalOpenAirtime, setModalOpenAirtime] = useState(false);
  const userMSISDN = JSON.parse(localStorage.getItem("MSISDN") || "null");
  const navigate = useNavigate();
  const [showPurchaseDataSuccess, setShowPurchaseDataSuccess] = useState(false);
  const [transactionIdPaystack, setTransactionIdPaystack] = useState("");
  const {
    register,
    handleSubmit,
    formState: { errors, isDirty, isValid },
  } = useForm();
  renderCount++;
  const inputValue = Watch("amount", "");

  const [count, setCount] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => setCount(count + 1), 1000);
    return () => clearTimeout(timer);
  }, []);

  const transactionIdRef = useRef("");

  const paystackReferenceId = useRef("");

  const [show, setShow] = useState(false);
  const [showTopupModal, setTopupModel] = useState(false);
  const [showMaximumAmountError, setShowMaximumAmountError] = useState(false);
  const [showAmount, setShowAmount] = useState(true);
  const [allWalletData, setAllWalletData] = useState("");
  const [walletDatum, setWalletDatum] = useState("");
  const [maximumAmountText, setMaximumAmountText] = useState("");
  const [convertedAmount, setConvertedAmount] = useState(0);
  const [dataTextMessage, setDataTextMessage] = useState("");
  const options = { maximumFractionDigits: 2 };

  const handleShowAmount = () => {
    setShowAmount(!showAmount);
  };
  const handleShowTopupModal = () => {
    setTopupModel(true);
  };
  const handleHideTopupModal = () => {
    setTopupModel(false);
  };

  const [data, setData] = useState([]);
  const [isPending, setIsPending] = useState(true);
  const [error, setError] = useState(null);

  const hasKycData = () => {
    return (
      subscribInfoProcessed &&
      subscribInfoProcessed.kycData &&
      Object.keys(subscribInfoProcessed.kycData).length > 0
    );
  };

  // console.log("hasKycData", hasKycData());

  useEffect(() => {
    const getData = {
      userId: hasKycData()
        ? subscribInfoProcessed?.kycData?.subscriberId
        : subscribInfoProcessed?.customerId,
      phoneNumber: userNumberDisplay,
      sourceType: "vitel-command-web",
    };

    setIsPending(true);
    vitelWirelessAxios
      .post("/payments/getWalletLedgerData", getData)
      .then((response) => {
        if (!response.statusText === "OK") {
          throw Error("Could not fetch data");
        } else {
          setIsPending(false);
        }
        setIsPending(false);
        setWalletDatum(response.data);
        // setData(response.data)

        setError(null);
      })
      .catch((error) => {
        setError(error.message);
        setIsPending(false);
      });
  }, []);

  const handleRefreshWallet = async () => {
    setRefreshPending(true);
    const getData = {
      userId: hasKycData()
        ? subscribInfoProcessed?.kycData?.subscriberId
        : subscribInfoProcessed?.customerId,
      phoneNumber: userNumberDisplay,
      sourceType: "vitel-command-web",
    };
    const wallets = await vitelWirelessAxios.post(
      "/payments/getWalletLedgerData",
      getData
    );

    if (wallets) {
      setRefreshPending(false);
    }
    setAllWalletData(wallets.data);
  };

  useEffect(() => {
    setAllWalletData(allWalletData);
  }, [allWalletData + 1]);

  const handleClose = () => setShow(false);
  const handleShow = (data) => {
    setShow(true);
    setWalletDisplayData(data);
  };

  const handleAmount = (e) => {
    const value = Number(e.target.value);
    setAmount(value);

    if (value > 25000) {
      setShowMaximumAmountError(true);
    } else {
      setShowMaximumAmountError(false);
    }
  };

  const walletDatas = walletDatum.walletData;

  const handleSubmitWalletAmount = async (data) => {
    setWalletTopUpPending(true);
    // const walletSendData = {
    //   userId: hasKycData()
    //     ? subscribInfoProcessed?.kycData?.subscriberId
    //     : subscribInfoProcessed?.customerId,
    //   type: "credit",
    //   amount: +amount,
    //   phoneNumber: userNumberDisplay,
    //   paidFor: "wallet-top-up",
    //   creditType: "card",
    //   billApplication: "vitelSubscriberWeb",
    //   billCode: "vs001",
    //   walletId: walletDatas?.walletId,
    //   sourceType: "vitel-command-web",
    //   transactionType: "wallet-top-up",
    //   paystackReference: paystackReferenceId.current,
    //   transactionId: paystackReferenceId.current,
    //   sourceFrom: "card",
    // };

    const walletSendData = {
      transactionType: "wallet-top-up",
      msisdn: userNumberDisplay,
      amount: +amount,
      referenceId: paystackReferenceId.current,
      // i_account: parseInt(iAccount), // For airtime top-up
      // portalOneProductId: "", // For data top-up
      rechargeType: "wallet-top-up", // For data purchases
      // autoRenewal: false, // For data purchases
      sourceType: "vitel-command-web",
      partnerId: null,
      employeeId: hasKycData()
        ? subscribInfoProcessed?.kycData?.subscriberId
        : subscribInfoProcessed?.customerId,
      walletId: CustomerLedger?.walletId,
      actionType: "create",
      sourceFrom: "paystack", // Specific action type
      fundingSource: "paystack",
      // idempotencyKey: clientIdempotencyKey,
      metadata: {},
    };

    // console.log("walletData>>> neew today", walletSendData);
    await vitelWirelessAxios
      .post("subscribers/subscribe-creates-log-Transaction", walletSendData)
      .then((res) => {
        console.log("res", res.data);
        setWalletTopUpPending(false);
        setTopupModel(false);
        handleRefreshWallet();
        setFirstPaystackCallPending(false);
        setPurchaseDate(new Date().toISOString().slice(0, 19).replace("T", " "));
        setModalOpenAirtime(true);
        setDataTextMessage("Wallet Top Up Successful");
      })
      .catch((err) => {
        setWalletTopUpPending(false);
      });
  };

  const lastCustomerLedger =
    allWalletData.lastCustomerLedger || walletDatum.lastCustomerLedger;
  const CustomerLedger =
    allWalletData.ledgerRecords || walletDatum.ledgerRecords;
  //  console.log("CustomerLedger>>>", CustomerLedger)
  const handlePaystackCloseAction = () => {};

  const handSubscriberInfo = (reference) => {
    setPayReference(reference.reference);
    const payStackObj = {
      amount: amount,
      email: subscribInfoProcessed?.emailAddress,
      paystackPaymentReference: reference.reference,
    };

    airTimeTopUpData = payStackObj;
  };

  const config = {
    reference: new Date().getTime().toString(),
    email: subscribInfoProcessed?.emailAddress,
    amount: amount * 100,
    currency: "NGN",
    channels: ["bank", "card", "ussd"],
    publicKey: process.env.REACT_APP_PAYSTACK_KEY,
  };
  const componentProps = {
    ...config,
    text: "Pay via bank ",
    onSuccess: (reference) => {
      // handlePaystackSuccessAction(reference);
    },
    onClose: handlePaystackCloseAction,
  };

  const handleCheckAvailableBalance = async () => {
    const MAX_ALLOWED_AMOUNT = 20000;

    const currentBalance = Number(lastCustomerLedger?.currentBalance) || 0;
    const enteredAmount = Number(amount) || 0;

    const remainingLimit = MAX_ALLOWED_AMOUNT - currentBalance;

    if (enteredAmount > remainingLimit) {
      setShowMaximumAmountError(true);
      return;
    }

    payWithPaystack();
  };

  // const payWithPaystack = () => {
  //   handleFirstPaystackCall();
  //   const handler = window.PaystackPop.setup({
  //     key: process.env.REACT_APP_PAYSTACK_KEY,
  //     email: subscribInfoProcessed?.emailAddress,
  //     amount: amount * 100,

  //     ref: transactionIdRef.current,
  //     callback: function (response) {
  //       setPayReference(response.reference);
  //       paystackReferenceId.current = response.reference;
  //       handleSecondPaystackCall(response.reference);
  //     },
  //     onClose: function () {
  //       // alert('Payment closed');
  //     },
  //   });
  //   handler.openIframe();
  // };

  const payWithPaystack = async () => {
    try {
      // console.log("Starting first paystack call...");

      await handleFirstPaystackCall();

      // console.log(
      //   "transactionIdRef.current after API call:",
      //   transactionIdRef.current
      // );

      if (!transactionIdRef.current) {
        alert("Failed to initialize transaction. Please try again.");
        return;
      }

      const handler = window.PaystackPop.setup({
        key: process.env.REACT_APP_PAYSTACK_KEY,
        email: subscribInfoProcessed?.emailAddress,
        amount: amount * 100,
        ref: transactionIdRef.current,
        metadata: {
          extraData: [
            {
              userId: hasKycData()
                ? subscribInfoProcessed?.kycData?.subscriberId
                : subscribInfoProcessed?.customerId,
              type: "credit",
              actionType: "wallet-top-up",
              amount: +amount,
              phoneNumber: userNumberDisplay,
              paidFor: "wallet-top-up",
              creditType: "card",
              billApplication: "vitelSubscriberWeb",
              billCode: "vs001",
              walletId: walletDatas?.walletId,
              sourceType: "vitel-command-web",
              transactionType: "wallet-top-up",
              paystackReference: paystackReferenceId.current,
            },
          ],
        },
        callback: function (response) {
          setPayReference(response.reference);
          paystackReferenceId.current = response.reference;
          handleSubmitWalletAmount(response.reference);
          // handleSecondPaystackCall(response.reference);
        },
        onClose: function () {},
      });

      handler.openIframe();
    } catch (error) {
      console.error("Error in payWithPaystack:", error);
      alert("Failed to initialize payment. Please try again.");
    }
  };

  const handleFirstPaystackCall = async () => {
    setFirstPaystackCallPending(true);
    const payLoad = {
      MSISDN: userNumberDisplay,
      amount: amount,
      actionType: "create",
      rechargeType: "wallet-top-up",
      transactionType: "wallet-top-up",
      employeeId: hasKycData()
        ? subscribInfoProcessed?.kycData?.subscriberId
        : subscribInfoProcessed?.customerId,
      // employeeId: subscribInfoProcessed?.kycData?.subscriberId,
      walletId: walletDatas?.walletId,
      sourceType: "vitel-command-web",
      // paystackReference: "paystack_" + new Date().getTime(),
      // transactionId: "walletTopup_" + new Date().getTime(),
      isSuccess: "false",
      sourceFrom: "paystack",
      fundingSource: "paystack",
    };
    await vitelWirelessAxios
      .post("subscribers/new-log-transaction-x1", payLoad)
      .then((response) => {
        setFirstPaystackCallPending(false);
        console.log("response.data.transactionId", response.data);
        transactionIdRef.current = response.data.transactionId;
        setTransactionIdPaystack(response.data.transactionId);
        setPurchaseDate(
          new Date().toISOString().slice(0, 19).replace("T", " ")
        );
      })
      .catch((error) => {});
  };

  const handleSecondPaystackCall = async (refrence) => {
    setFirstPaystackCallPending(true);
    const payLoad = {
      MSISDN: userNumberDisplay,
      amount: amount,
      actionType: "update",
      transactionType: "wallet-top-up",
      rechargeType: "wallet-top-up",
      sourceType: "vitel-command-web",
      paystackReference: transactionIdRef.current,
      transactionId: transactionIdRef.current,
      isSuccess: "true",
      sourceFrom: "paystack",
      fundingSource: "paystack",
    };

    // console.log("NOWWWWWW>>>>coming-send", payLoad);
    await vitelWirelessAxios
      .post("subscribers/new-log-transaction-x1", payLoad)
      .then((response) => {
        handleSubmitWalletAmount();
        // console.log("paystack-successful>>>>", response);
        setFirstPaystackCallPending(false);
        setPurchaseDate(
          new Date().toISOString().slice(0, 19).replace("T", " ")
        );
      })
      .catch((error) => {});
  };

  useEffect(() => {
    let timeout;
    if (success) {
      timeout = setTimeout(() => {
        setSuccess(false);
      }, 5000);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [success]);

  const handleShowStateMEnt = () => {
    setShowStateMent(true);
  };
  const handleGoback = () => {
    setShowStateMent(false);
  };

  const checkColorPayment = (description) => {
    switch (description) {
      case "credit":
        return "green";
      case "debit":
        return "red";
      default:
    }
  };

  useEffect(() => {
    setTransData(CustomerLedger);
  }, [CustomerLedger + 1]);

  const filterTransactionType = (e) => {
    const transValue = e.target.value;

    const filteredTransData =
      CustomerLedger &&
      CustomerLedger.filter((data) => data.type === transValue);
    setTransData(filteredTransData);
    // console.log("filterTransactionType>>>", filteredTransData)
  };

  const filterTransactions = (transactions, months) => {
    const now = new Date();
    return (
      CustomerLedger &&
      CustomerLedger.filter((transaction) => {
        const transactionDate = new Date(transaction.createdDateTime);
        const diffTime = Math.abs(now - transactionDate);
        const diffMonths = diffTime / (1000 * 60 * 60 * 24 * 30);
        return diffMonths <= months;
      })
    );
  };
  const navigateBack = () => navigate(-1);
  const filterLastMonth = (CustomerLedger) =>
    filterTransactions(CustomerLedger, 1);
  const filterLastTwoMonths = (CustomerLedger) =>
    filterTransactions(CustomerLedger, 2);
  const filterLastSixMonths = (CustomerLedger) =>
    filterTransactions(CustomerLedger, 6);

  // Use the filter functions:

  const lastMonthTransactions = filterLastMonth(CustomerLedger);
  const lastTwoMonthsTransactions = filterLastTwoMonths(CustomerLedger);
  const lastSixMonthsTransactions = filterLastSixMonths(CustomerLedger);

  const handleTransactionPeriod = (e) => {
    const changeDate = e.target.value;
    if (changeDate === "oneMonth") {
      setTransData(lastMonthTransactions);
    } else if (changeDate === "twoMonth") {
      setTransData(lastTwoMonthsTransactions);
    } else if (changeDate === "sixMonth") {
      setTransData(lastTwoMonthsTransactions);
    } else if (changeDate === "all") {
      setTransData(CustomerLedger);
    }
  };

  const receiptRef = useRef(null);

  const tableRef = useRef(null);

  const downloadReceipt = async () => {
    if (receiptRef.current) {
      const canvas = await html2canvas(receiptRef.current);
      const imgData = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = imgData;
      link.download = "receipt.png";
      link.click();
    }
  };

  const shareReceipt = async () => {
    if (navigator.share) {
      try {
        const canvas = await html2canvas(receiptRef.current);
        canvas.toBlob((blob) => {
          const file = new File([blob], "receipt.png", { type: "image/png" });
          navigator.share({
            files: [file],
            title: "Receipt",
            text: "Here is your repair receipt",
          });
        }, "image/png");
      } catch (error) {
        console.error("Error sharing receipt:", error);
      }
    } else {
      alert("Sharing not supported on this device");
    }
  };

  // History download and share functions//////////////////////////
  const downloadReceiptHistory = async () => {
    if (tableRef.current) {
      const canvas = await html2canvas(tableRef.current);
      const imgData = canvas.toDataURL("image/png");

      const timestamp = Date.now(); // e.g. 1732054339091

      const link = document.createElement("a");
      link.href = imgData;
      link.download = `receipt_${timestamp}.png`;
      link.click();
    }
  };

  const shareReceiptHistory = async () => {
    if (navigator.share) {
      try {
        const canvas = await html2canvas(tableRef.current);
        canvas.toBlob((blob) => {
          const file = new File([blob], "receipt.png", { type: "image/png" });
          navigator.share({
            files: [file],
            title: "Receipt",
            text: "Here is your repair receipt",
          });
        }, "image/png");
      } catch (error) {
        console.error("Error sharing receipt:", error);
      }
    } else {
      alert("Sharing not supported on this device");
    }
  };

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  useEffect(() => {
    setSidebarOpen(false);
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Only paginate if data exists
  const totalItems = CustomerLedger?.length || 0;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  // Slice only if more than 10
  const currentItems =
    totalItems > itemsPerPage
      ? CustomerLedger.slice(indexOfFirstItem, indexOfLastItem)
      : CustomerLedger;

  const goToPage = (pageNum) => setCurrentPage(pageNum);
  const nextPage = () =>
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  const prevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));

  const { totalDeposits, totalSpending, totalTransactions } =
    CalcWalletStat(transData);

  return (
    <>
      <div className="app-container app-theme-white body-tabs-shadow fixed-sidebar fixed-header">
        <SubHeader toggleSidebar={toggleSidebar} sidebarOpen={sidebarOpen} />
        <div className="app-main" style={{ paddingTop: "0" }}>
          <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
          <div className="app-main__outer">
            <div>
              <div className="dashboard-subheader-modern">
                <div className="subheader-content">
                  {/* Left Section - Brand & Navigation */}
                  <div className="subheader-left">
                    <div className="brand-section">
                      <div className="brand-text">
                        <h1 className="brand-title">Vitel Wireless Command</h1>
                        <p className="brand-subtitle">Wallet Management</p>
                      </div>
                    </div>
                  </div>

                  {/* Right Section - Navigation & Notifications */}
                  <div className="subheader-right">
                    {/* Back Navigation */}
                    <button className="back-navigation" onClick={navigateBack}>
                      <div className="back-icon">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <path d="M19 12H5M12 19l-7-7 7-7" />
                        </svg>
                      </div>
                      <span className="back-text">Back</span>
                    </button>

                    {/* Notifications */}
                    {/* <div className="notifications-section">
                      <button className="notification-btn">
                        <div className="notification-icon">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                            <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                          </svg>
                          <span className="notification-badge">3</span>
                        </div>
                        <span className="notification-label">
                          Notifications
                        </span>
                      </button>

                     
                      <div className="notification-dropdown">
                        <div className="notification-header">
                          <h3>Notifications</h3>
                          <button className="mark-all-read">
                            Mark all as read
                          </button>
                        </div>
                        <div className="notification-list">
                          <div className="notification-item unread">
                            <div className="notification-icon success">✓</div>
                            <div className="notification-content">
                              <p className="notification-title">
                                Top-up Successful
                              </p>
                              <p className="notification-time">2 minutes ago</p>
                            </div>
                          </div>
                          <div className="notification-item">
                            <div className="notification-icon info">ℹ</div>
                            <div className="notification-content">
                              <p className="notification-title">
                                New Feature Available
                              </p>
                              <p className="notification-time">1 hour ago</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
              <div className="wallet-container">
                {showStateMent ? (
                  // Transaction History View

                  <div className="transaction-history">
                    <div className="transaction-history-header">
                      {/* Header Section */}
                      <div className="history-header-main">
                        <div className="header-left">
                          <button
                            className="back-button-modern"
                            onClick={handleGoback}
                          >
                            <span className="back-icon">
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                              >
                                <path d="M19 12H5M12 19l-7-7 7-7" />
                              </svg>
                            </span>
                            <span className="back-text">Back to Wallet</span>
                          </button>
                        </div>

                        <div className="header-center">
                          <div className="title-section">
                            <div>
                              <h1 className="page-title">
                                Transaction History
                              </h1>
                              <p className="page-subtitle">
                                View and filter your wallet transactions
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="header-right">
                          <div className="header-stats">
                            <div className="stat-badge">
                              <span className="stat-number">
                                {totalTransactions || 0}
                              </span>
                              <span className="stat-label">Total</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Filters Section */}
                      <div className="filters-section-modern">
                        <div className="filters-header">
                          <div className="filters-title">
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                            >
                              <polygon points="22,3 2,3 10,12.5 10,19 14,21 14,12.5 22,3" />
                            </svg>
                            <span>Filter Transactions</span>
                          </div>
                          <button className="clear-filters-btn">
                            Clear All
                          </button>
                        </div>

                        <div className="filters-grid">
                          <div className="filter-group-modern">
                            <label className="filter-label-modern">
                              <span className="label-text">
                                Transaction Type
                              </span>
                              <select
                                onChange={filterTransactionType}
                                className="filter-select-modern"
                              >
                                <option value="">All Types</option>
                                <option value="credit">Credit</option>
                                <option value="debit">Debit</option>
                              </select>
                            </label>
                          </div>

                          <div className="filter-group-modern">
                            <label className="filter-label-modern">
                              <span className="label-text">Time Period</span>
                              <select className="filter-select-modern">
                                <option value="">All Time</option>
                                <option value="oneMonth">Past Month</option>
                                <option value="twoMonth">Past 2 Months</option>
                                <option value="sixMonth">Past 6 Months</option>
                              </select>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    {transData && transData.length === 0 ? (
                      <div className="empty-state">
                        <h3>No Transaction History Found</h3>
                        <p>Your transaction history will appear here</p>
                      </div>
                    ) : (
                      <>
                        <div className="table-container">
                          <table className="transactions-table">
                            <thead>
                              <tr>
                                <th>Type</th>
                                <th>Balance Before</th>
                                <th>Amount</th>
                                <th>Current Balance</th>
                                <th>Date</th>
                                <th>Purpose</th>
                                <th>Details</th>
                              </tr>
                            </thead>
                            <tbody>
                              {currentItems &&
                                currentItems.map((data) => (
                                  <tr key={data.walletLedgerId}>
                                    <td>
                                      <span
                                        className="transaction-type"
                                        style={{
                                          color: checkColorPayment(data.type),
                                        }}
                                      >
                                        {data.type}
                                      </span>
                                    </td>
                                    <td>
                                      {symbol}
                                      {Intl.NumberFormat(
                                        "en-US",
                                        options
                                      ).format(data.preBalance)}
                                    </td>
                                    <td>
                                      {symbol}
                                      {Intl.NumberFormat(
                                        "en-US",
                                        options
                                      ).format(data.amount)}
                                    </td>
                                    <td>
                                      {symbol}
                                      {Intl.NumberFormat(
                                        "en-US",
                                        options
                                      ).format(data.currentBalance)}
                                    </td>
                                    <td>
                                      {new Date(
                                        data.createdDateTime
                                      ).toLocaleDateString()}
                                    </td>
                                    <td>{data.paidFor}</td>
                                    <td>
                                      <button
                                        className="view-details-btn"
                                        onClick={() => handleShow(data)}
                                      >
                                        View
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>

                        {totalPages > 1 && (
                          <div className="pagination">
                            <button
                              className="pagination-btn"
                              onClick={prevPage}
                              disabled={currentPage === 1}
                            >
                              Previous
                            </button>
                            <div className="page-numbers">
                              {[...Array(totalPages)].map((_, idx) => (
                                <button
                                  key={idx}
                                  className={`page-btn ${
                                    currentPage === idx + 1 ? "active" : ""
                                  }`}
                                  onClick={() => goToPage(idx + 1)}
                                >
                                  {idx + 1}
                                </button>
                              ))}
                            </div>
                            <button
                              className="pagination-btn"
                              onClick={nextPage}
                              disabled={currentPage === totalPages}
                            >
                              Next
                            </button>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                ) : (
                  // Wallet Overview
                  <div className="wallet-overview">
                    <div className="wallet-card-modern">
                      <div className="card-header-modern">
                        <div className="header-content">
                          <div className="wallet-icon">
                            <IoCardOutline size={40} color="white" />
                          </div>
                          <div>
                            <h2 className="card-title">My Wallet</h2>
                            <p className="card-subtitle">
                              Vitel Wireless Account
                            </p>
                          </div>
                        </div>
                        {/* <button
                          className="refresh-btn-modern"
                          onClick={handleRefreshWallet}
                          disabled={refreshPending}
                        >
                          {refreshPending ? (
                            <div className="spinner-modern"></div>
                          ) : (
                            <>
                              <span className="refresh-icon">
                                <IoRefresh size={30} color="white" />
                              </span>
                            </>
                          )}
                        </button> */}
                      </div>

                      <div className="balance-section-modern">
                        <div className="balance-header">
                          <span className="balance-label-modern">
                            Available Balance
                          </span>
                        </div>

                        <div className="balance-display-modern">
                          {showAmount ? (
                            <div className="balance-amount-modern">
                              <span className="currency-symbol">{symbol}</span>
                              {Number(
                                lastCustomerLedger?.currentBalance || 0
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </div>
                          ) : (
                            <div className="balance-hidden-modern">
                              <span className="hidden-dots">•••••</span>
                            </div>
                          )}

                          <div className="balance-controls">
                            <button
                              className="visibility-toggle"
                              onClick={handleShowAmount}
                              aria-label={
                                showAmount ? "Hide balance" : "Show balance"
                              }
                            >
                              <span className="toggle-icon">
                                {showAmount ? (
                                  <IoEye size={20} color="white" />
                                ) : (
                                  <IoEyeOff size={30} color="white" />
                                )}
                              </span>
                            </button>

                            <button
                              className="refresh-btn-modern"
                              onClick={handleRefreshWallet}
                              disabled={refreshPending}
                            >
                              {refreshPending ? (
                                <div className="spinner-modern"></div>
                              ) : (
                                <>
                                  <span className="refresh-icon">
                                    <IoRefresh size={30} color="white" />
                                  </span>
                                </>
                              )}
                            </button>
                          </div>
                        </div>

                        <div className="balance-footer">
                          <span className="balance-status">
                            Live balance • Updated just now
                          </span>
                        </div>
                      </div>

                      <div className="wallet-actions-modern">
                        {/* <button
                          className="action-btn-modern secondary"
                          onClick={handleShowStateMEnt}
                        >
                          View Statement
                        </button> */}
                        <button
                          className="action-btn-modern primary"
                          onClick={() => setTopupModel(true)}
                        >
                          Top Up Wallet
                        </button>
                      </div>
                    </div>

                    <div className="wallet-stats-modern">
                      <div className="stat-card-modern">
                        <div className="stat-icon income">↑</div>
                        <div className="stat-content">
                          <div className="stat-value-modern">
                            {symbol}
                            {totalDeposits?.toLocaleString()}
                          </div>
                          <div className="stat-label-modern">
                            Total Deposits
                          </div>
                          {/* <div className="stat-trend positive">
                            +12% this month
                          </div> */}
                        </div>
                      </div>

                      <div className="stat-card-modern">
                        <div className="stat-icon spending">↓</div>
                        <div className="stat-content">
                          <div className="stat-value-modern">
                            {symbol}
                            {totalSpending?.toLocaleString()}
                          </div>
                          <div className="stat-label-modern">
                            Total Spending
                          </div>
                          {/* <div className="stat-trend negative">
                            -5% this month
                          </div> */}
                        </div>
                      </div>

                      <div className="stat-card-modern">
                        <div className="stat-icon transactions">↔</div>
                        <div className="stat-content">
                          <div className="stat-value-modern">
                            {totalTransactions}
                          </div>
                          <div className="stat-label-modern">Transactions</div>
                          {/* <div className="stat-trend neutral">
                            +8% this month
                          </div> */}
                        </div>
                      </div>
                    </div>

                    {/* <div className="recent-transactions">
                      <h2 className="section-title-recent-trans">
                        Recent Transactions
                      </h2>

                      {isPending || refreshPending ? (
                        <div className="loading-state">
                          <div className="spinner"></div>
                          <p>Loading transactions...</p>
                        </div>
                      ) : CustomerLedger && CustomerLedger.length === 0 ? (
                        <div className="empty-state">
                          <div className="empty-icon">💳</div>
                          <h3>No Recent Transactions Found</h3>
                          <p>Your recent transactions will appear here</p>
                        </div>
                      ) : (
                        <div className="table-container">
                          <table className="transactions-table">
                            <thead>
                              <tr>
                                <th>Type</th>
                                <th>Balance Before</th>
                                <th>Amount</th>
                                <th>Current Balance</th>
                                <th>Date</th>
                                <th>Purpose</th>
                                <th>Details</th>
                              </tr>
                            </thead>
                            <tbody>
                              {transData &&
                                transData.slice(0, 8).map((data, index) => (
                                  <tr key={data.walletLedgerId}>
                                    <td>
                                      <span
                                        className="transaction-type"
                                        style={{
                                          color: checkColorPayment(data.type),
                                        }}
                                      >
                                        {data.type}
                                      </span>
                                    </td>
                                    <td>
                                      {symbol}
                                      {Intl.NumberFormat(
                                        "en-US",
                                        options
                                      ).format(data.preBalance)}
                                    </td>
                                    <td>
                                      {symbol}
                                      {Intl.NumberFormat(
                                        "en-US",
                                        options
                                      ).format(data.amount)}
                                    </td>
                                    <td>
                                      {symbol}
                                      {Intl.NumberFormat(
                                        "en-US",
                                        options
                                      ).format(data.currentBalance)}
                                    </td>
                                    <td>
                                      {new Date(
                                        data.createdDateTime
                                      ).toLocaleDateString()}
                                    </td>
                                    <td>{data.paidFor}</td>
                                    <td>
                                      <button
                                        className="view-details-btn"
                                        onClick={() => handleShow(data)}
                                      >
                                        View
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div> */}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        isOpen={show}
        onClose={handleClose}
        size="md"
        className="details-modal-clean"
        title={"Transaction Details"}
      >
        <div className="modal-body-clean">
          {/* Header Section */}
          <div className="modal-body-clean" ref={tableRef}>
            <div className="transaction-header">
              <div className="company-details">
                <h3 className="company-name">Vitel Wireless</h3>
                <p className="transaction-type">
                  {walletDisplayData.type} Transaction
                </p>
              </div>

              <div className="amount-section">
                <div className="amount-label">Amount</div>
                <div className="amount-value">
                  {symbol}
                  {Intl.NumberFormat("en-US", options).format(
                    walletDisplayData.amount
                  )}
                </div>
                <div className={`transaction-badge ${walletDisplayData.type}`}>
                  {walletDisplayData.type}
                </div>
              </div>
            </div>

            {/* Transaction Details */}
            <div className="details-section">
              <div className="details-grid">
                <div className="detail-item">
                  <span className="detail-label">Transaction ID</span>
                  <span className="detail-value">
                    {walletDisplayData.walletLedgerId}
                  </span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Date & Time</span>
                  <span className="detail-value">
                    {moment(walletDisplayData.createdDateTime).format("lll")}
                  </span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Previous Balance</span>
                  <span className="detail-value">
                    {symbol}
                    {Intl.NumberFormat("en-US", options).format(
                      walletDisplayData.preBalance
                    )}
                  </span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Current Balance</span>
                  <span className="detail-value">
                    {symbol}
                    {Intl.NumberFormat("en-US", options).format(
                      walletDisplayData.currentBalance
                    )}
                  </span>
                </div>

                <div className="detail-item">
                  <span className="detail-label">Purpose</span>
                  <span className="detail-value">
                    {walletDisplayData?.paidFor}
                  </span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Payment Method</span>
                  <span className="detail-value">
                    {walletDisplayData?.creditType}
                  </span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Application</span>
                  <span className="detail-value">
                    {walletDisplayData?.billApplication}
                  </span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Reference Code</span>
                  <span className="detail-value">
                    {walletDisplayData?.billCode}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="modal-actions-clean">
            <button className="btn-clean btn-secondary" onClick={handleClose}>
              Close
            </button>
            <div className="action-buttons">
              <button
                className="btn-clean btn-outline"
                onClick={downloadReceiptHistory}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="7 10 12 15 17 10" />
                  <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
                Download
              </button>
              <button
                className="btn-clean btn-outline"
                onClick={shareReceiptHistory}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                  <polyline points="16 6 12 2 8 6" />
                  <line x1="12" y1="2" x2="12" y2="15" />
                </svg>
                Share
              </button>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={showTopupModal}
        onClose={handleHideTopupModal}
        size="sm"
        className="topup-modal-clean"
        title={"Top Up Wallet"}
      >
        <div className="modal-body-clean">
          <p className="modal-description">
            Enter the amount you wish to add to your wallet
          </p>

          <Form
            onSubmit={handleSubmit((data) => {})}
            className="topup-form-clean"
          >
            {/* Amount Input */}
            <div className="input-group-clean">
              <label className="input-label">Amount</label>
              <div className="amount-input-container">
                <span className="currency-prefix">{symbol}</span>
                <input
                  type="number"
                  placeholder="0.00"
                  className="amount-input-clean"
                  value={amount}
                  onChange={handleAmount}
                  min="100"
                  max="25000"
                />
              </div>
              <div className="amount-limits-clean">
                Min: {symbol}100 • Max: {symbol}25,000
              </div>
            </div>

            {/* Error Message */}
            {showMaximumAmountError && (
              <div className="error-message-clean">
                Maximum amount exceeded. Please adjust the amount.
              </div>
            )}

            {/* Action Buttons */}
            <div className="modal-actions-clean">
              <button
                type="button"
                className="btn-clean btn-secondary"
                onClick={handleHideTopupModal}
              >
                Cancel
              </button>

              {firstPaystackCallPending ? (
                <button className="btn-clean btn-primary loading" disabled>
                  Processing...
                </button>
              ) : (
                <button
                  className="btn-primary-topup"
                  disabled={amount < 250 || amount > 20000}
                  onClick={handleCheckAvailableBalance}
                >
                  Continue to Pay
                </button>
              )}
            </div>
          </Form>
        </div>
      </Modal>

      <Modal
        isOpen={isModalOpenAirtime}
        onClose={() => setModalOpenAirtime(false)}
        title={"Top Up Successful"}
      >
        <div className="receipt" id="download-receipt" ref={receiptRef}>
          <header className="receipt__header">
            <i>
              <img src={logo} style={{ width: "70px" }} />{" "}
            </i>
            <p className="receipt__title">
              Vitel Wireless Top up Wallet Receipt
            </p>
            <p className="receipt__date">{purchaseDate}</p>
          </header>
          <dl className="receipt__list">
            <div className="receipt__list-row">
              <dt className="receipt__item">Amount</dt>
              <dd className="receipt__cost"> {amount} </dd>
            </div>

            <div className="receipt__list-row">
              <dt className="receipt__item">Customer name</dt>
              <dd className="receipt__cost">
                {" "}
                {subscribInfoProcessed?.firstName}{" "}
                {subscribInfoProcessed?.lastName}
              </dd>
            </div>
            <div className="receipt__list-row">
              <dt className="receipt__item">Payment reference</dt>
              <dd className="receipt__cost"> {payReference}</dd>
            </div>
            <div className="receipt__list-row">
              <dt className="receipt__item">Transaction Id</dt>
              <dd className="receipt__cost"> {transactionIdPaystack}</dd>
            </div>
            <div className="receipt__list-row">
              <dt className="receipt__item">Message</dt>
              <dd className="receipt__cost"> {dataTextMessage}</dd>
            </div>

            <div className="receipt__list-row receipt__list-row--total">
              <dt className="receipt__item">Total price</dt>
              <dd className="receipt__cost"> ₦{amount} </dd>
            </div>
          </dl>
        </div>

        <div
          style={{
            textAlign: "end",
            justifyContent: "end",
            display: "flex",
            gap: "10px",
          }}
        >
          <Button
            variant="secondary"
            onClick={() => setModalOpenAirtime(false)}
          >
            Cancel
          </Button>
          <div id="legalcopy">
            <div className="backToHome d-flex">
              <Button onClick={downloadReceipt} style={{ cursor: "pointer" }}>
                <span className="shareIconspan">
                  <IoMdArrowDown className="saveIcon" />
                </span>
                <span>Download Receipt</span>
              </Button>

              <Button onClick={shareReceipt} style={{ cursor: "pointer" }}>
                <span className="shareIconspan">
                  <IoMdShare className="saveIcon" />
                </span>
                <span>Share Receipt</span>
              </Button>
            </div>
          </div>
        </div>
      </Modal>

      {/* <NewFooter /> */}
    </>
  );
};

export default SubscribersWallet;
